import { render } from "./museumEducational.vue?vue&type=template&id=155b9955"
import script from "./museumEducational.vue?vue&type=script&lang=js"
export * from "./museumEducational.vue?vue&type=script&lang=js"

import "./museumEducational.vue?vue&type=style&index=0&id=155b9955&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__